// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f499119","648":"134307a0"}[chunkId] + ".chunk.js";
};